// 主组件
import BiDashboard from './index.vue'
import Preview from './components/preview/index.vue'

// 组件
import ChartRender from './components/charts/middleLayer.vue'
import ChartEngineRender from './components/charts/chartRender.vue'
import cTabs from './components/base/cTabs.vue'

// 工具函数
import * as utils from './utils/index.js'

// 配置
import * as panelConfig from './config/panelConf.js'
import * as enumData from './utils/enum.data.js'

// Store - 内部使用，不暴露
import { storeConfig } from './store/index.js'

// 模拟数据
import * as mockData from './mock/charts.js'

import './assets/style/tailwind.css'
// import './assets/theme/element.define.css';
// import './assets/theme/index.css';
import './assets/style/base.less'
const exportModule = {
  BiDashboard,
  Preview,
  ChartRender,
  ChartEngineRender,
  cTabs,
  utils,
  panelConfig,
  enumData,
  storeConfig,
  mockData
}

// 导出所有组件
export {
  BiDashboard,
  Preview,
  ChartRender,
  ChartEngineRender,
  cTabs,
  utils,
  panelConfig,
  enumData,
  storeConfig,
  mockData
}

// 默认导出主组件
export default exportModule

// 安装函数，用于 Vue.use()
export const install = function(Vue, options = {}) {
  // 确保 Vuex 已安装
  if (!Vue.prototype.$store) {
    console.warn('Vuex is required for @cdsp/bi-dashboard. Please install Vuex first.')
  }
  
  // 全局配置
  if (options.config) {
    Vue.prototype.$cdspBiDashboardConfig = options.config
  }
  
  // 提供 store 配置给外部使用（如果需要的话）
  Vue.prototype.$cdspBiDashboardStoreConfig = storeConfig
}

// 支持 Vue.use() 安装
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
